import { FC, ReactNode, useState, useEffect, useCallback } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { AuthUser, setAuthToken, removeAuthToken, getCurrentUser } from '../services/authService';

interface AuthProviderProps {
	children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
	const [user, setUser] = useState<AuthUser | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadUser = async () => {
			try {
				const currentUser = await getCurrentUser();
				setUser(currentUser);
			} catch (error) {
				console.error('Failed to load user:', error);
				setUser(null);
			} finally {
				setLoading(false);
			}
		};

		loadUser();
	}, []);

	const login = useCallback((authUser: AuthUser, token: string) => {
		setAuthToken(token);
		setUser(authUser);
	}, []);

	const logout = useCallback(() => {
		removeAuthToken();
		setUser(null);
		window.location.href = '/login';
	}, []);

	const refreshUser = useCallback(async () => {
		try {
			const currentUser = await getCurrentUser();
			setUser(currentUser);
		} catch (error) {
			console.error('Failed to refresh user:', error);
			logout();
		}
	}, [logout]);

	return <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>{children}</AuthContext.Provider>;
};
